module.exports = __webpack_public_path__ + "media/images/v2/plus-circle-96d06f138c0ed24153a2dc72d6c60155.svg";